export default __webpack_public_path__ + "static/media/winner-illustration-with-stars.3796228c.svg";